<!--
* @Name：工程类认定申请审批银行信息
* @Author: 王超
* @Date: 2024-12-16
-->
<template>
  <div>
    <hi-card v-for="(item, index) in dataList" :key="item.poCreateItemId" :row-index="index + 1">
      <van-row>
        <span>公司名称：</span>
        <span>{{ item.corpName }}</span>
      </van-row>
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>账户名称：</span>
        <span>{{ item.bankAccountName }}</span>
      </van-row>
      <van-row>
        <span>银行名称：</span>
        <span>{{ item.bankName }}</span>
      </van-row>
      <van-row>
        <span>银行账户：</span>
        <span>{{ item.bankAccount }}</span>
      </van-row>
      <van-row>
        <span>付款方式：</span>
        <span>{{ item.payMethod | dictFilter(payMethodOptions) }}</span>
      </van-row>
      <van-row>
        <span>付款条件：</span>
        <span>{{ item.payTerm | dictFilter(payTermOptions) }}</span>
      </van-row>
      <van-row>
        <span>核销方式：</span>
        <span>{{ item.verifyWay | dictFilter(verifyWayOptions) }}</span>
      </van-row>
      <van-row>
        <span>开户行号：</span>
        <span>{{ item.bankCode }}</span>
      </van-row>
      <van-row>
        <span>近三年征信情况：</span>
        <span>{{ item.creditStatus }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'BankInfo',
  data() {
    return {}
  },
  props: {
    // 银行明细列表
    dataList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // 付款方式参照
    payMethodOptions() {
      return this.$store.getters.dicts.pay_method
    },
    // 付款条件参照
    payTermOptions() {
      return this.$store.getters.dicts.pay_term
    },
    // 核销方式参照
    verifyWayOptions() {
      return this.$store.getters.dicts.verify_way
    }
  },
  methods: {}
}
</script>
